import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
const CollectionIntroTabs = (props) => {
    var _a, _b, _c, _d;
    const [tabIndex, setTabIndex] = useState(0);
    const introLink = (introLink, tabTitleAnalytics) => {
        var _a;
        const introLinkData = introLink.data;
        const dataAnalytics = `{"event": "${props.type}", "eventCategory": "${props.type}", "eventAction": "banner-interaction", "eventLabel": "${props.collectionTitleAnalytics + ' - ' + tabTitleAnalytics + ' - ' + (introLinkData.linkText_analytics || introLinkData.linkText)}"}`;
        return (React.createElement("a", { className: "button button--tertiary button--arrow-right", href: introLinkData.link, "data-analytics-id": "${pdict.uuid}", "data-analytics": dataAnalytics }, introLinkData.linkText || ((_a = introLink.custom) === null || _a === void 0 ? void 0 : _a.categoryName)));
    };
    const introTab = (introTab, i) => {
        const introTabData = introTab.data;
        const dataAnalytics = `{"event": "${props.type}", "eventCategory": "${props.type}", "eventAction": "banner interaction", "eventLabel": "${`${props.collectionTitleAnalytics}-${introTabData.tabTitle_analytics || introTabData.tabTitle}`.toLowerCase()}"}`;
        return (React.createElement("button", { className: "collection-intro__tab-name", "data-analytics-id": introTab.id, "data-analytics": dataAnalytics }, introTabData.tabTitle));
    };
    const introTabPanel = (introTab, i) => {
        var _a;
        return (React.createElement("ul", { className: "tabs-collection-links" }, (_a = introTab.link) === null || _a === void 0 ? void 0 : _a.map((il) => {
            var _a;
            return (React.createElement("li", { className: "collections-intro__link", key: il.id }, introLink(il, (_a = introTab.data) === null || _a === void 0 ? void 0 : _a.tabTitle_analytics)));
        })));
    };
    if (props.withTabs && ((_a = props.collectionsTab) === null || _a === void 0 ? void 0 : _a.length)) {
        return (React.createElement(Tabs, { "data-option-tabs": props.withTabs, "data-type": props.type, selectedIndex: tabIndex, onSelect: (index) => setTabIndex(index) },
            React.createElement(TabList, { className: "collection-intro__links" }, (_b = props.collectionsTab) === null || _b === void 0 ? void 0 : _b.map((c, i) => {
                if (!c.type_id.includes('_link')) {
                    return (React.createElement(Tab, { className: "collections-intro__tab", selectedClassName: "active", key: c.id }, introTab(c, i)));
                }
            })), (_c = props.collectionsTab) === null || _c === void 0 ? void 0 :
            _c.map((c, i) => {
                if (!c.type_id.includes('_link')) {
                    return (React.createElement(TabPanel, { key: c.id, className: "collection-intro__link-wrapper" }, introTabPanel(c, i)));
                }
            })));
    }
    else if ((_d = props.collectionsTab) === null || _d === void 0 ? void 0 : _d.length) {
        return (React.createElement("div", { className: "collection-intro__link-wrapper", "data-type": props.type },
            React.createElement("ul", { className: "collection-intro__links" }, props.collectionsTab &&
                props.collectionsTab.map((c, i) => {
                    if (c.type_id.includes('_link')) {
                        return (React.createElement("li", { className: "collections-intro__link", key: c.id }, introLink(c)));
                    }
                }))));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default CollectionIntroTabs;
